/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} ViewInputs */



/**
* | output |
* | --- |
* | "View" |
*
* @param {ViewInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const view = /** @type {((inputs?: ViewInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<ViewInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Affichage")
	if (locale === "de") return /** @type {LocalizedString} */ ("Sicht")
	if (locale === "it") return /** @type {LocalizedString} */ ("Visualizzazione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Вид")
	if (locale === "es") return /** @type {LocalizedString} */ ("Vista")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("看法")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ビュー")
	if (locale === "hi") return /** @type {LocalizedString} */ ("देखना")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Visualizar")
	return /** @type {LocalizedString} */ ("View")
});